/**
 * Screen-reader announcement for a terms-consent step that appears asynchronously — after the
 * login form's partial response (Landing) or the consent probe (MSTeamsLanding). Neither flow
 * moves focus, so a persistent live region is the only thing that tells a screen-reader user
 * that a required step, and the reason for it, just appeared.
 *
 * Shared by both pages so they announce the same framing their visible copy uses. The
 * full-page interstitials (TermsConsentPage, MSTeamsOAuthTocConsent) need no announcement:
 * they are fresh page loads, announced normally.
 */

import { i18n } from "~vue/i18n";

/** An unknown or missing reason falls back to first-time framing, as the consent components do. */
function reasonDetail(reason?: string): string {
    const { t } = i18n.global;
    switch (reason) {
        case "updated":
            return t("components.termsConsent.updated");
        case "grandfathered":
            return t("components.termsConsent.grandfathered");
        default:
            return t("components.termsConsent.firstTime");
    }
}

/** Resolved on every call, not in module constants, so the text follows a language switch. */
export function termsConsentAnnouncement(reason?: string): string {
    return `${i18n.global.t("components.termsConsent.requirement")} ${reasonDetail(reason)}`;
}
